module.exports = __webpack_public_path__ + "img/success.70dae065.svg";